const Draw = ({ ...props }) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="70"
      height="70"
      viewBox="0 0 70 70"
      fill="none"
    >
      <circle cx="35" cy="35" r="33" stroke="#333333" strokeWidth="3.5" />
      <path
        d="M35.001 3.73682L35.001 10.6842"
        stroke="#333333"
        strokeWidth="3.5"
        strokeLinecap="round"
      />
      <path
        d="M35.001 59.3157L35.001 66.263"
        stroke="#333333"
        strokeWidth="3.5"
        strokeLinecap="round"
      />
      <path
        d="M57.1074 12.8936L52.1949 17.8061"
        stroke="#333333"
        strokeWidth="3.5"
        strokeLinecap="round"
      />
      <path
        d="M17.8066 52.1938L12.8941 57.1063"
        stroke="#333333"
        strokeWidth="3.5"
        strokeLinecap="round"
      />
      <path
        d="M57.1074 57.1064L52.1949 52.1939"
        stroke="#333333"
        strokeWidth="3.5"
        strokeLinecap="round"
      />
      <path
        d="M17.8066 17.8062L12.8941 12.8937"
        stroke="#333333"
        strokeWidth="3.5"
        strokeLinecap="round"
      />
      <path
        d="M66.2617 35L59.3144 35"
        stroke="#333333"
        strokeWidth="3.5"
        strokeLinecap="round"
      />
      <path
        d="M10.6836 35L3.73623 35"
        stroke="#333333"
        strokeWidth="3.5"
        strokeLinecap="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36.6276 18.948C36.3126 18.4159 35.7401 18.0895 35.1218 18.0895C34.5034 18.0895 33.9309 18.4159 33.6159 18.948L24.976 33.5408C24.8758 33.71 24.8074 33.8891 24.769 34.0713C23.956 35.6393 23.4971 37.4168 23.4971 39.2967C23.4971 45.6606 28.726 50.7753 35.1213 50.7753C41.5166 50.7753 46.7455 45.6606 46.7455 39.2967C46.7455 37.418 46.2872 35.6417 45.4752 34.0744C45.4369 33.8912 45.3683 33.7109 45.2676 33.5408L36.6276 18.948ZM41.9741 34.8482L35.1218 23.2745L28.2677 34.851C28.2282 35.0113 28.1651 35.1687 28.0772 35.3185C27.3899 36.4891 26.9971 37.8457 26.9971 39.2967C26.9971 43.6787 30.6098 47.2753 35.1213 47.2753C39.6328 47.2753 43.2455 43.6787 43.2455 39.2967C43.2455 37.8457 42.8527 36.4891 42.1654 35.3185C42.077 35.1679 42.0137 35.0095 41.9741 34.8482Z"
        fill="#FC8037"
      />
      <path
        d="M39.25 39.5C39.25 41.4308 37.4937 43.25 35 43.25C32.5063 43.25 30.75 41.4308 30.75 39.5C30.75 37.5692 32.5063 35.75 35 35.75C37.4937 35.75 39.25 37.5692 39.25 39.5Z"
        stroke="#FC8037"
        strokeWidth="3.5"
      />
    </svg>
  )
}

export default Draw
